var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.6,104c10.3,0,19.7-3.9,26.9-10.3l2.3,2.3l-2.1,2.2c-1.2,1.2-1.2,3.1,0,4.3l18,18.2c0.6,0.6,1.3,0.9,2.1,0.9s1.6-0.3,2.1-0.9l8-8.1c1.1-1.2,1.1-3.1-0.1-4.2l-18-18.2c-0.6-0.6-1.3-0.9-2.1-0.9s-1.6,0.3-2.1,0.9l-2.1,2.2L87.2,90c6.3-7.3,10.2-16.8,10.2-27.2c0-22.7-18.3-41.2-40.8-41.2c-22.5,0-40.8,18.5-40.8,41.2C15.8,85.6,34.1,104,56.6,104z M93.8,96.6l13.8,14l-3.8,3.8l-13.8-14L93.8,96.6z M56.6,27.7c19.2,0,34.8,15.8,34.8,35.2S75.8,98,56.6,98S21.8,82.3,21.8,62.9S37.4,27.7,56.6,27.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1,58.6c0.3,0.1,0.6,0.2,0.9,0.2c1.1,0,2.1-0.7,2.5-1.8c2.4-6.9,9-11.6,16.2-11.6c1.4,0,2.6-1.2,2.6-2.6s-1.2-2.6-2.6-2.6c-9.5,0-18,6.1-21.2,15.1C35,56.6,35.7,58.2,37.1,58.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8,70.5c1.4,0,2.6-1.2,2.6-2.6l0-0.3c0-1.5-1.1-2.7-2.6-2.7c0,0,0,0-0.1,0c-1.4,0-2.6,1.1-2.6,2.6l0,0.4C35.2,69.3,36.3,70.5,37.8,70.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.79efd547f60aa0c54da876f0f0c4fd5c.svg";
export { ForwardRef as ReactComponent };